<template>
  <div class="page">
    <pre>
      所有被保险人已阅读以下信息，且同意并确认以下条款及告知内容：
      一、所有“湖南爱民保”被保险人须属于基本医保的参保人（含湖南省本级、各市州），包括城镇职工、城乡居民和新市民。
      二、所有被保险人已阅读“湖南爱民保”适用的投保须知、产品说明书、理赔须知、免责条款、客户告知书、保险条款、授权申明、信息安全及保密承诺书、用户协议等各项内容，特别是有关保障说明、责任免除和被保险人义务的相关内容，保险公司就上述保险条款履行了说明义务，被保险人已知悉并同意接受该条款及参保须知的全部内容。
      三、所有被保险人应如实填写投保信息，并就保险公司提出的提示询问据实告知，否则保险公司有权依据《中国人民共和国保险法》第十六条的规定解除保险合同且不承担赔偿责任：
      （一）订立保险合同时，保险公司就保险标的或者被保险人的有关情况提出询问的，投保人应当如实告知。
      （二）投保人故意或者因重大过失未履行前款规定的如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同。
      （三）投保人故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。
      （四）投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，但退还保险费。
      所有被保险人确认上述告知信息属实，如出现虚假情况，将不享受本保险相关待遇。
      四、本合同约定的保险责任起止时间为：2022.7.25-2022.9.30投保的保险期间为2022.10.1-2023.9.30；2022.10.1-2022.11.30投保的保险期间为2022.12.1-2023.11.30；2022.12.1-2022.12.31投保的保险期间为2023.1.1-2023.12.31
      五、可通过关注“湖南爱民保”微信公众号了解更多服务详情。
    </pre>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  components: {}
}
</script>

<style lang="scss" scoped>
pre {
  padding: 0 10px;
  font-size: 13px;
  line-height: 20px;
  font-weight: 400;
  color: #666;
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>
